export default {
  acordar_horario: 'Scheduled time',
  asientos: 'Seat',
  atencion: 'Attention !!!',
  atencion_texto1: 'Make the payment for your reservation or create another route and continue traveling.',
  atencion_texto2: '',
  alojamiento: 'Accommodation name and/or address',

  boton_condiciones: 'See policies',
  btn_pagar: 'Pay reservation',
  btn_continuar: 'Continue',
  buscar: 'Search',
  buscar_transfer: 'Search transfer',
  buscando: 'Searching',

  cancela_1: 'Cancel your reservation!!',
  cancela_2: 'Free cancellation up to 48 hours of the trip',
  cancela_3: '',
  cancelar: 'Cancel',
  cancelar_reserva: 'Cancel booking',
  cantidad_pasajeros: 'Passengers',
  cargando: 'Loading',
  codigo_pais_invalido: 'Invalid country code',
  control_cant_pasajeros: 'Check the number of passengers',
  control_fecha_mayor_igual_hoy: 'The date must be greater than today',
  confirmar: 'Confirm',
  confirmar_pago_pix: 'Confirm PIX payment',
  cerrar: 'Close',
  confirmar_reserva: 'Confirm reservation',
  confirmar_reservas: 'Continue booking',
  confirmar_reserva_y_pagar: 'Confirm reservation and select payment method...',
  comprobante_pago_pix: 'PIX payment receipt',
  comprobante_requerido: 'Proof required',
  configuracion_medio_no_encontrada: 'Configuration for {medio} not found. Code ({codigo}).',
  control_datos_pasajeros: 'You must fill in the passenger details',
  control_email: 'Complete email correctly',
  control_movil: 'Complete Phone',
  condiciones: 'See alteration and cancellation policies',
  costo_total: 'Total cost',
  consultar_precio: 'Check the price',

  datos_de_la_reserva: 'Reservation data',
  datos_del_viaje: 'Trip data',
  de: 'From',
  dia: 'Day',

  eliminar_trayecto_1: 'Delete route?',
  eliminar: 'Delete',
  elimina_trayectos_cargados: 'Delete loaded routes?',
  email: 'Email',
  email_enviado: 'E-mail sent',
  enviar_email: 'Send email',
  enviando_email: 'Sending email',
  err_enviando_email: 'Problems sending email',
  err_network_connection: 'Verify connection to server. Please try again later or contact technical support..',
  error_alta_reserva: 'We could not confirm the reservation. If it continues, contact support and share the code shown.',
  estados_reserva: {
    estado_0: 'With error',
    estado_1: 'Issued',
    estado_2: 'Pending payment',
    estado_40: '',
    estado_45: '',
    estado_50: 'Pending payment confirmation at destination (payment on board)',
    estado_55: 'Payment at destination confirmed (payment on board)',
    estado_60: '',
    estado_70: 'Payment with QR code PIX pending confirmation',
    estado_98: 'Paid (not processed)',
    estado_99: 'Processed'
  },

  falta_poco: '¡Almost there! Fill in your details to continue with the payment',
  falta_poco_pantalla3: 'Verify the details of your reservation are correct and confirm the payment',
  fecha_transfer: 'Transfer date',
  formato_comprobante_pix: 'Allowed formats: PDF, JPG, JPEG, PNG. Maximum size: 10MB',

  no_hay_resultados: 'No results found',
  no_elimino_trayecto: 'Did not delete path',
  servicios: 'Services',
  servicios_otra_informacion: 'More information for your trip',
  precio_por_pasajero: 'Price per passenger',
  politica_privacidad: 'Privacy Policy',

  datos_de_los_pasajeros: 'Passenger data',
  distancia_total: 'Total distance',
  tiempo_estimado: 'Estimated travel time',

  confirma_tus_datos_personales: 'Confirm your personal information',
  nombre_de_pasajeros: 'Full names of passengers',
  pasajeros: 'Passengers name',
  contacto: 'Contact',
  movil: 'Phone',
  movil_whatsapp: 'Whatsapp - Phone',
  completar_los_siguientes_datos: 'Complete the following information',
  control_completar: 'Complete',
  trayectos: 'Transfer booking details',
  aerolinea: 'Airline company',
  nro_vuelo: 'Flight number',

  horario_del_vuelo: 'Flight schedule',
  hotel_posada_en: 'Hotel/inn in ',
  hs: 'hr',

  intercambiar_origen_destino: 'Swap origin and destination',

  no_encontro_resultado: 'No Results Found',

  otros_datos: 'Other data',

  transfer: 'Transfer',
  transfer_privado: 'Private transfer',
  transfer_regular: 'Regular transfer',
  transfer_horario: 'Transfer schedule',
  trayecto: 'Routes',
  trayectos_intercambiados: 'Swapped routes',
  te_enviamos_voucher: 'We´ll send your booking voucher here',
  total: 'Total',
  terminos: 'I declare that I have read the Privacy Policy and that I accept the Booking Terms and Conditions and the Transportation Terms and Conditions',
  terminos_y_condiciones: 'Terms & conditions',

  metodo_de_pago: 'Payment method',
  plataforma_de_pago: 'Payment platform',
  hora: 'Hour',
  hora_llegada: 'Arrival time',
  debe_aceptar_terminos: 'You must accept Terms and Conditions',
  debe_aceptar_politica_cancelamiento: 'You must accept Cancellation Policies',
  saliendo_de: 'Leaving from',
  llegando_a: 'Arriving to',
  conozca_stripe: 'Click... meet Stripe',
  nombres_completos: 'Complete names',
  detalle_reserva: 'Booking detail',

  limpiar: 'Clean',
  limpiar_busqueda: 'Clean search',

  maletas_1: 'Bags per person',
  maletas_2: 'A medium suitcase',
  maletas_3: 'A small suitcase',
  modifica_1: 'Modify your reservation',
  modifica_2: 'Modify your reservation free of charge at any time',
  modifica_3: '',
  monto_a_pagar: 'Amount to pay',
  mostrar_pre_reserva: 'Open Pre Reservation',
  medios_de_pago: 'Payment methods',
  medios_de_pago_seleccione: 'Select payment method',
  modificar_reserva: 'Modify reservation',
  medios_pagos_no_configurados: 'Payment methods not configured',

  centro_ayuda: 'Help center',
  atencion_clientes: 'Customer service',

  pagar: 'Pay',
  pagar_reserva: 'Pay booking',
  para: 'Arriving to',
  pago_con_tarjeta: 'Payment by credit or debit card',
  pago_con_tarjeta_txt: 'Pay with credit or debit card',
  pago_con_paypal: 'Payment with Paypal',
  pago_con_paypal_txt: 'Pay with Paypal account',
  pago_con_pix: 'Payment with QR code PIX',
  pago_con_pix_pendiente_de_confirmacion: 'Payment with QR code PIX pending confirmation',
  pago_con_pix_txt: 'Pay with QR code PIX',
  pago_a_bordo: 'Payment at destination (cash, on board)',
  pago_a_bordo_txt: 'Pay in cash upon arrival',
  pago_a_bordo_representante: 'One of our representatives will contact you to confirm the reservation',
  pago_a_bordo_completar_datos: 'You must complete: contact, email and mobile',
  pago_a_bordo_confirmado: 'Excellent, we have confirmed your payment at destination (payment on board)',
  pago_pix_instrucciones: 'Read the QR code with your application, pay and confirm the payment by loading the payment receipt',
  pago_por_stripe: 'Confirm the payment of your reservation with credit or debit card',
  precio: 'Price',
  preparando_pago_stripe: 'Please wait, preparing payment on Stripe ...',
  preparando_pago_paypal: 'Please wait, preparing payment in Paypal ...',
  preparando_pago_paguelofacil: 'Please wait, preparing payment in Páguelo Fácil ...',
  preparando_pago_pix: 'Please wait, preparing payment with QR code PIX ...',

  reserva: 'Booking',
  reserva_confirmada: 'Your reservation has been confirmed, shortly you will receive the details of the trip',
  reserva_id: 'Booking id',
  reserva_no_confirmada: 'Your reservation has NOT been confirmed',
  reserva_ya_no_disponible: 'This reservation is no longer available',
  reserva_pago_a_bordo: 'Payment on board reservation. Our staff will contact you to confirm it',
  reserva_link_pago: 'Reservation pending shipment and payment confirmation via payment link',
  reserva_pendiente: 'Reservation pending payment',
  reserva_pago_a_bordo_confirmada: 'Reservation with payment on board confirmed',
  reservar: 'Reserve',
  ruta: 'Routes',

  seleccionar_comprobante_pix: 'Select PIX payment receipt',
  seleccionar_otro_trayecto: 'Add another route',
  seleccionar_horario: 'Select schedule',
  sesion_expiro: 'The session expired',
  sub_total: 'Subtotal',
  seleccione_ambos_puntos: 'Select both points to see the route',
  stripe_no_devolvio_url: 'Please verify your payment because Stripe did not return the sample URL for the reservation',

  no_gracias: 'No, thanks',
  espero_contacten: 'I hope you contact me',

  telefono_contacto: 'Mobile phone number',
  telefono_contacto_msq: 'Mobile phone number to contact you for any eventuality',
  telefono_placeholder: 'Phone number',
  telefono_placeholder_msg: 'Phone number to contact the lead passenger',
  tipo_servicio: 'Type of service',
  tipo_transfer: {
    bu: 'Regular bus transfer',
    mb: 'Regular mini bus transfer',
    va: 'Regular shuttle van',
    t3: 'Private transfer from 1 to 3 people',
    t5: 'Private transfer up to 5 people',
    t6: 'Private transfer up to 6 people',
    bp: 'Private bus transfer',
    mp: 'Private mini bus transfer',
    vp: 'Private transfer van up to 13 people',
    auto03: 'Private car transfer 1 to 3 people',
    auto08: 'Private car transfer 4 to 8 people',
    auto12: 'Private car transfer 9 to 12 people',
    auto16: 'Private car transfer 13 to 16 people',
    auto20: 'Private car transfer 17 to 20 people',
    auto25: 'Private car transfer 21 to 25 people',
    auto30: 'Private car transfer 26 to 30 people',
    hasta4: 'Private up to 4 passengers',
    hasta5: 'Private up to 5 passengers',
    hasta5_suburban: 'Suburban up to 5 passengers',
    hasta6: 'Private up to 6 passengers',
    hasta8: 'Private up to 8 passengers',
    hasta10: 'Private up to 10 passengers',
    hasta13: 'Private up to 13 passengers',
    hasta17: 'Private up to 17 passengers',
    hasta22: 'Private up to 22 passengers'
  },

  ordinal_trayecto: {
    ordinal_1: 'First',
    ordinal_2: 'Second',
    ordinal_3: 'Third',
    ordinal_4: 'Fourth',
    ordinal_5: 'Fifth',
    ordinal_6: 'Sixth',
    ordinal_7: 'Seventh'
  },

  ver_ruta_en_mapa: 'View route on the map',
  ver_punto_en_mapa: 'View point on the map',
  verificar_parametros: 'Check the parameters',
  version: 'v.',
  powered_by: 'Powered by',
  volver_atras: 'Go back'
}
